import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Equipo } from '@domain/equipo';
import { Jugador } from '@domain/jugador';
import { DesafioEquipoProvider } from '@providers/desafio-equipo/desafio-equipo';
import { EstatusRetosEquipo } from '@domain/estatus.reto.equipo';
import { TabsPage } from '@pages';
import { EstatusRetoEnum } from '@domain/estatus.reto.enum';
import { AuthProvider } from '@providers/auth/auth';

@IonicPage()
@Component({
  selector: 'page-resultado-tc',
  templateUrl: 'resultado-tc.html',
})
export class ResultadoTcPage {

  equipo: Equipo;
  jugador: Jugador = new Jugador;
  resultados: any = {
    jugador: '',
    equipo: '',
    totalCorrectas: 0,
    totalIncorrectas: 0,
    estadisticas: []
  };
  puntosAportados: number = 0;
  estatus: EstatusRetosEquipo = new EstatusRetosEquipo;
  ESTATUS_RETO_ENUM = EstatusRetoEnum;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private authProvider: AuthProvider,
    private desafioEquipoProvider: DesafioEquipoProvider
  ) {
    this.equipo = this.navParams.get('equipo');
    this.jugador = this.navParams.get('jugador');
    this.resultados = this.navParams.get('resultados');

  }

  async ionViewDidLoad() {
    if(this.resultados){
      this.puntosAportados = this.resultados.estadisticas.reduce( (n, m) => n + m.puntos, 0 );
    }

    try {
      const estatus = await this.desafioEquipoProvider.estatus(this.equipo.area._id, this.equipo._id, this.jugador._id);
      this.estatus = estatus;
      console.log(estatus)
      if(this.estatus.estatus === this.ESTATUS_RETO_ENUM.EXISTE_GANADOR) {
        this.authProvider.setWinner(null);
      }
    } catch (error) {
      
    }
  }

  siguiente() {
    this.navCtrl.setRoot(TabsPage, {
      active: 1
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/team-challenge/resultado-tc/resultado-tc.ts